import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { companySchema } from './company'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const companyLocationSchema = z.object({
    address: z.string().nullish(),
    company: z.lazy(() => companySchema.nullish()),
    company_uuid: z.uuid().nullish(),
    country_uuid: z.uuid().nullish(),
    created_at: zDayJs.nullish(),
    description: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_default: z.boolean().nullish(),
    is_physical: z.boolean().nullish(),
    is_postal: z.boolean().nullish(),
    latitude: z.number().nullish(),
    longitude: z.number().nullish(),
    name: z.string().nullish(),
    postcode: z.string().nullish(),
    region_uuid: z.uuid().nullish(),
    street_one: z.string().nullish(),
    street_two: z.string().nullish(),
    status: z.string().nullish(),
    suburb: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const companyLocationsSchema = z.array(companyLocationSchema)

export const paginatedCompanyLocationsResponseSchema = z.object({
    data: companyLocationsSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveCompanyLocationResponseSchema = z.object({
    data: companyLocationSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export type CompanyLocation = z.infer<typeof companyLocationSchema>
export type CompanyLocations = z.infer<typeof companyLocationsSchema>
export type PaginatedCompanyLocationsResponse = z.infer<
    typeof paginatedCompanyLocationsResponseSchema
>
export type RetrieveCompanyLocationResponse = z.infer<typeof retrieveCompanyLocationResponseSchema>
